import Fingerprint from 'fingerprintjs2';
import axios from 'axios'

try { 
    axios.defaults.headers.common['X-CSRF-TOKEN'] = document
        .querySelector('meta[name="csrf-token"]')
        .content

    const digestToHex = digest =>
            Array
            .from(new Uint8Array(digest))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('')

    const encodeText = text => new TextEncoder().encode(text)

    const calculateFingerprint = (components) =>
        crypto.subtle.digest(
            'SHA-256',
            encodeText(components.map(x => x.value).join(''))
        )
        .then(digestToHex)

    const addFingerprintToForm = () =>
        Fingerprint.get({}, (components) =>
            calculateFingerprint(components)
            .then(fingerprint =>
                axios.post('/browsers', {
                    fingerprint: fingerprint,
                    raw_data: JSON.stringify(components)
                })
            )
        )

    if (window.requestIdleCallback) {
        requestIdleCallback(addFingerprintToForm)
    } else {
        setTimeout(addFingerprintToForm, 500)
    }

} catch (error) {
    // Finger printing failure, probably because of lack of CSRF token
}